angular
    .module('eficienciaFiscalModule')
    .filter('ncm', () => {
        return (input) => {
            const formatter = ncm => ncm.length >= 7 
                ? ncm.replace(/(\d{4})(\d{2})(\d+)/, '$1.$2.$3')
                : ncm.replace(/(\d{4})(\d+)/, '$1.$2');

            if (typeof(input) === 'string') {
                return formatter(input)
            }
        }
    })
